import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "aria-label": "Page navigation example" }
const _hoisted_2 = { class: "pagination justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  class: "page-link",
  href: "#",
  tabindex: "-1"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "이전"),
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "이전")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("a", {
  class: "page-link",
  href: "#"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "다음"),
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "다음")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      _createVNode("li", {
        class: ["page-item", { disabled: _ctx.disablePrev }],
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevClick && _ctx.prevClick(...args)))
      }, [
        _hoisted_3
      ], 2),
      _createVNode("li", {
        class: ["page-item", { disabled: _ctx.disableNext }],
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextClick && _ctx.nextClick(...args)))
      }, [
        _hoisted_4
      ], 2)
    ])
  ]))
}